import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { RECOMMEND_APPS } from '../recommendMockData';

/**
 * 应用 / 推荐位 树（真实 RecommendSlotTree.vue）
 * onChange({ slotId, slotName, slotCode, appId })
 */
const RecommendSlotTree = ({ onChange }) => {
    const [appList] = useState(() => RECOMMEND_APPS.filter(a => (a.slots || []).length > 0));
    const [currentSlotId, setCurrentSlotId] = useState(null);
    const [collapsed, setCollapsed] = useState([]);

    // 自动选中第一个推荐位
    useEffect(() => {
        if (appList.length && appList[0].slots.length) {
            const first = appList[0].slots[0];
            setCurrentSlotId(first.id);
            onChange({ slotId: first.id, slotName: first.name, slotCode: first.code, appId: appList[0].appId });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleApp = (appId) => setCollapsed(prev => (prev.includes(appId) ? prev.filter(i => i !== appId) : [...prev, appId]));

    const handleSlotClick = (slot, appId) => {
        setCurrentSlotId(slot.id);
        onChange({ slotId: slot.id, slotName: slot.name, slotCode: slot.code, appId });
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#fff', overflow: 'hidden', borderRight: '1px solid #ebeef5' }}>
            <div style={{ padding: '14px 16px', borderBottom: '1px solid #ebeef5', flexShrink: 0 }}>
                <span style={{ fontSize: 14, color: '#303133', fontWeight: 600 }}>应用 / 推荐位</span>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
                {appList.map((app, idx) => (
                    <div key={app.appId} style={idx > 0 ? { borderTop: '1px solid #ebeef5' } : undefined}>
                        <div
                            style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', background: '#f8f9fb', cursor: 'pointer' }}
                            onClick={() => toggleApp(app.appId)}
                        >
                            <DownOutlined style={{ fontSize: 14, color: '#c0c4cc', transform: collapsed.includes(app.appId) ? 'rotate(-90deg)' : 'none', transition: 'transform .3s' }} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 13, color: '#303133', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{app.appName}</div>
                                <div style={{ fontSize: 11, color: '#c0c4cc', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{app.appId}</div>
                            </div>
                        </div>

                        {!collapsed.includes(app.appId) && app.slots.map(slot => {
                            const active = slot.id === currentSlotId;
                            return (
                                <div
                                    key={slot.id}
                                    onClick={() => handleSlotClick(slot, app.appId)}
                                    style={{
                                        padding: '7px 12px 7px 36px', cursor: 'pointer', position: 'relative',
                                        background: active ? '#ecf5ff' : 'transparent',
                                        borderLeft: active ? '3px solid #409eff' : '3px solid transparent',
                                    }}
                                >
                                    <div style={{ fontSize: 13, color: active ? '#409eff' : '#606266', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{slot.name}</div>
                                    <div style={{ fontSize: 11, color: '#c0c4cc', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{slot.code}</div>
                                </div>
                            );
                        })}
                    </div>
                ))}

                {appList.length === 0 && <div style={{ padding: 24 }}><Empty description="暂无应用数据" /></div>}
            </div>
        </div>
    );
};

export default RecommendSlotTree;
